const baseURL = "/v1/MotivoRejeicao";

const service = {
  methods: {
    $buscarMotivo(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $obterDadosMotivo({id, params}) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarMotivo(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarMotivo(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarMotivo(body, id) {
      return this.$api().patch(`${baseURL}/${id}`, body);
    },
  },
};

export default service;
